import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './Components/GlobalStyles.css';

// Check for existing session on app load
const checkExistingSession = () => {
  const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';
  const user = sessionStorage.getItem('user');

  return { isAuthenticated, user: user ? JSON.parse(user) : null };
};

// Set initial auth state
window.userAuth = checkExistingSession();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
